export function zoomFunction(zoom) {
	let el = document.getElementsByClassName('page-container')[0];
	if(el) {
		let transformOrigin = [0, 0];
		let p = ["webkit", "moz", "ms", "o"],
			s = "scale(" + zoom + ")",
			oString = (transformOrigin[0] * 100) + "% " + (transformOrigin[1] * 100) + "%";

		for (var i = 0; i < p.length; i++) {
			// @ts-ignore
			el.style[p[i] + "Transform"] = s;
			// @ts-ignore
			el.style[p[i] + "TransformOrigin"] = oString;
		}
		// @ts-ignore
		el.style["transform"] = s;
		// @ts-ignore
		el.style["transformOrigin"] = oString;
	}


}